const initialClientGroupState = {
  fetching: false,
  fetched: false,
  items: [],
  selected: [],
  error: null
};

export const clientGroupSuggestionsReducer = (
  state = initialClientGroupState,
  action
) => {
  switch (action.type) {
    case "INIT_CLIENT_GROUP_SUGGESTIONS": {
      return initialClientGroupState;
    }
    case "FETCH_CLIENT_GROUP_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_CLIENT_GROUP_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data
      };
    }
    case "FETCH_CLIENT_GROUP_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_DYNAMIC_TABLE_FILTER_CLIENT_GROUP":
    case "SET_FILTER_CLIENT_GROUP": {
      return {
        ...state,
        selected: action.groups
      };
    }
    default:
      return state;
  }
};

const initialClientState = {
  fetching: false,
  fetched: false,
  items: [],
  selected: [],
  error: null
};

export const clientSuggestionsReducer = (
  state = initialClientState,
  action
) => {
  switch (action.type) {
    case "INIT_DYNAMIC_TABLE_DATA":
    case "INIT_CLIENT_SUGGESTIONS": {
      return initialClientState;
    }
    case "FETCH_CLIENT_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_CLIENT_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data
      };
    }
    case "FETCH_CLIENT_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_DYNAMIC_TABLE_FILTER_CLIENT":
    case "SET_FILTER_CLIENT": {
      return {
        ...state,
        selected: action.clients
      };
    }
    default:
      return state;
  }
};

const initialCollaboratorState = {
  fetching: false,
  fetched: false,
  items: [],
  selected: [],
  role: null,
  error: null
};

export const collaboratorSuggestionsReducer = (
  state = initialCollaboratorState,
  action
) => {
  switch (action.type) {
    case "INIT_COLLABORATOR_SUGGESTIONS": {
      return initialCollaboratorState;
    }
    case "FETCH_COLLABORATOR_SUGGESTIONS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_COLLABORATOR_SUGGESTIONS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data
      };
    }
    case "FETCH_COLLABORATOR_SUGGESTIONS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_DYNAMIC_TABLE_FILTER_COLLABORATOR":
    case "SET_FILTER_COLLABORATOR": {
      return {
        ...state,
        selected: action.collaborators
      };
    }
    case "SET_FILTER_COLLABORATOR_ROLE": {
      return {
        ...state,
        role: action.role
      };
    }
    default:
      return state;
  }
};

const initialTaskCategoryState = {
  items: [],
  selected: []
};

export const TaskCategorySuggestionsReducer = (
  state = initialTaskCategoryState,
  action
) => {
  switch (action.type) {
    case "INIT_TASK_CATEGORY_SUGGESTIONS": {
      return initialPeriodUnitState;
    }
    case "SET_FILTER_TASK_CATEGORY": {
      return {
        ...state,
        selected: action.types
      };
    }
    default:
      return state;
  }
};

const initialYearState = {
  selected: []
};

export const yearSuggestionsReducer = (state = initialYearState, action) => {
  switch (action.type) {
    case "INIT_YEAR_SUGGESTIONS": {
      return initialYearState;
    }
    case "SET_FILTER_YEAR": {
      return {
        ...state,
        selected: action.year
      };
    }
    default:
      return state;
  }
};

const initialPeriodUnitState = {
  items: [],
  selected: "year"
};

export const periodUnitSuggestionsReducer = (
  state = initialPeriodUnitState,
  action
) => {
  switch (action.type) {
    case "INIT_PERIOD_UNIT_SUGGESTIONS": {
      return initialPeriodUnitState;
    }
    case "SET_FILTER_PERIOD_UNIT": {
      return {
        ...state,
        selected: action.unit
      };
    }
    default:
      return state;
  }
};

const initialPeriodsState = {
  selected: []
};

export const periodsSuggestionsReducer = (
  state = initialPeriodsState,
  action
) => {
  switch (action.type) {
    case "INIT_PERIODS_SUGGESTIONS": {
      return initialPeriodsState;
    }
    case "SET_FILTER_PERIODS": {
      return {
        ...state,
        selected: action.periods
      };
    }
    default:
      return state;
  }
};

const initialZoneState = {
  fetching: false,
  fetched: false,
  items: [],
  selected: [],
  error: null
};

export const zoneSuggestionsReducer = (state = initialZoneState, action) => {
  switch (action.type) {
    case "INIT_ZONE_SUGGESTIONS": {
      return initialZoneState;
    }
    case "FETCH_ZONE_SUGGESTIONS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_ZONE_SUGGESTIONS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data
      };
    }
    case "FETCH_ZONE_SUGGESTIONS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_FILTER_ZONE": {
      return {
        ...state,
        selected: action.zones
      };
    }
    default:
      return state;
  }
};

const initialBusinessUnitState = {
  fetching: false,
  fetched: false,
  items: [],
  selected: [],
  error: null
};

export const businessUnitSuggestionsReducer = (
  state = initialBusinessUnitState,
  action
) => {
  switch (action.type) {
    case "INIT_BUSINESS_UNIT_SUGGESTIONS": {
      return initialBusinessUnitState;
    }
    case "FETCH_BUSINESS_UNIT_SUGGESTIONS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_BUSINESS_UNIT_SUGGESTIONS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data
      };
    }
    case "FETCH_BUSINESS_UNIT_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_DYNAMIC_TABLE_FILTER_BUSINESS_UNIT":
    case "SET_FILTER_BUSINESS_UNIT": {
      return {
        ...state,
        selected: action.bu
      };
    }
    default:
      return state;
  }
};

const initialSquadState = {
  fetching: false,
  fetched: false,
  items: [],
  selected: [],
  error: null
};

export const squadsSuggestionsReducer = (state = initialSquadState, action) => {
  switch (action.type) {
    case "INIT_SQUAD_SUGGESTIONS": {
      return initialSquadState;
    }
    case "FETCH_SQUAD_SUGGESTIONS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_SQUAD_SUGGESTIONS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data
      };
    }
    case "FETCH_SQUAD_SUGGESTIONS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_DYNAMIC_TABLE_FILTER_SQUAD":
    case "SET_FILTER_SQUAD": {
      return {
        ...state,
        selected: action.squads
      };
    }
    default:
      return state;
  }
};
const initialEntityState = {
  fetching: false,
  fetched: false,
  items: [],
  selected: [],
  error: null,
  statusBudgetEco: "",
  deletedStatus: "NOT_DELETED",
  offshoreStatus: "",
  facturableStatus: "NON_FACTURABLE",
  isEntity: "1"
};
export const entitySuggestionsReducer = (
  state = initialEntityState,
  action
) => {
  switch (action.type) {
    case "INIT_ENTITY_SUGGESTIONS": {
      return initialEntityState;
    }
    case "FETCH_ENTITY_SUGGESTIONS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_ENTITY_SUGGESTIONS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data
      };
    }
    case "FETCH_ENTITY_SUGGESTIONS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_FILTER_ENTITY": {
      return {
        ...state,
        selected: action.payload.entityClientId,
        isEntity: action.payload.isEntity
      };
    }
    case "SET_CLIENT_IS_ENTITY_FILTER_STATE": {
      return {
        ...state,
        isEntity: action.payload.isEntity
      };
    }
    case "SET_CLIENT_STATUS_BUDGET_ECO": {
      return {
        ...state,
        statusBudgetEco: action.payload
      };
    }
    case "SET_CLIENT_DELETED_STATUS": {
      return {
        ...state,
        deletedStatus: action.payload
      };
    }
    case "SET_CLIENT_OFFSHORE_STATUS": {
      return {
        ...state,
        offshoreStatus: action.payload
      };
    }
    case "SET_CLIENT_FACTURABLE_STATUS": {
      return {
        ...state,
        facturableStatus: action.payload
      };
    }
    default:
      return state;
  }
};

const initialClusterState = {
  fetching: false,
  fetched: false,
  items: [],
  selected: [],
  error: null
};

export const clusterSuggestionsReducer = (
  state = initialClusterState,
  action
) => {
  switch (action.type) {
    case "INIT_CLUSTER_SUGGESTIONS": {
      return initialClusterState;
    }
    case "FETCH_CLUSTER_SUGGESTIONS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_CLUSTER_SUGGESTIONS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data
      };
    }
    case "FETCH_CLUSTER_SUGGESTIONS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_DYNAMIC_TABLE_FILTER_CLUSTER":
    case "SET_FILTER_CLUSTER": {
      return {
        ...state,
        selected: action.clusters
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/filter.js